import { inject, Injectable } from '@angular/core';
import { ValidateCartRequestDto } from './dtos/validate-cart.request.dto';
import { ValidateCartResponseDto } from './dtos/validate-cart.response.dto';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SuccessResponse } from '../shared/success-response';
import { environment } from '@orderna/admin-panel/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StoreCartValidationApiService {
  private http = inject(HttpClient);

  async validateCart(storeId: number, dto: ValidateCartRequestDto) {
    const response = await firstValueFrom(
      this.http.post<SuccessResponse<ValidateCartResponseDto>>(
        `${environment.api}/stores/${storeId}/cart-validation`,
        dto,
      ),
    );

    return response.data;
  }
}
